import React from 'react';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const getAthleteName = (athlete) => athlete?.name || 'TBA';
const getTeamName = (athlete) => athlete?.team?.name || athlete?.Team?.name || '';
const getAthleteBelt = (athlete) => athlete?.belt || '';

const styles = StyleSheet.create({
    page: { padding: '15 35', fontFamily: 'Helvetica', fontSize: 8.5, backgroundColor: '#ffffff', color: '#000000' },
    eventHeader: { textAlign: 'center', fontSize: 13, fontWeight: 'bold', marginBottom: 6, textTransform: 'uppercase', color: '#1e293b' },
    row: { flexDirection: 'row' },
    table: { width: '100%', borderTop: '1pt solid #000', borderLeft: '1pt solid #000', marginBottom: 6 },
    cell: { borderBottom: '1pt solid #000', borderRight: '1pt solid #000', padding: '4 5', justifyContent: 'center' },
    cellCenter: { alignItems: 'center', justifyContent: 'center', textAlign: 'center' },
    textCenter: { textAlign: 'center' },
    fontBold: { fontWeight: 'bold' },
    textBlue: { color: '#0000ff' },
    textRed: { color: '#ff0000' },
    textWhite: { color: '#ffffff' },
    bgBlue: { backgroundColor: '#0000ff' },
    bgRed: { backgroundColor: '#ff0000' },
    bgGray: { backgroundColor: '#e2e8f0' },
    bgYellow: { backgroundColor: '#ffff00' },
    font6: { fontSize: 6 },
    font7_5: { fontSize: 7.5 },
    font9: { fontSize: 9 },
    font11: { fontSize: 11 },
    font14: { fontSize: 14 }
});

const vrReasons = ["2 Pts 'Technical'", 'Head Requested', 'Gam-Jeom & Pt', 'Technical issue', 'Requested by CR', 'Rejected by CR'];

const PDFTASheetPage = ({ eventName, match, variant = 'Kyorugi' }) => {
    const blueName = getAthleteName(match?.BlueAthlete);
    const blueTeam = getTeamName(match?.BlueAthlete);
    const blueBelt = getAthleteBelt(match?.BlueAthlete);

    const redName = getAthleteName(match?.RedAthlete);
    const redTeam = getTeamName(match?.RedAthlete);
    const redBelt = getAthleteBelt(match?.RedAthlete);

    const matchNo = match?.match_num || match?.match_no || '-';
    const dateText = match?.date || match?.match_date || new Date().toLocaleDateString('en-GB');
    const dayNo = match?.day || '-';
    const courtNo = match?.arena ? `Arena ${match.arena}` : '-';
    const weightCategory = `${variant} ${match?.division || ''} ${match?.weight_class || ''}`.trim();
    const hitLevel = match?.hit_level || '';
    const pssSize = match?.pss_size || '';

    const blueNoc = blueBelt ? `${blueTeam} | Sabuk ${blueBelt}` : blueTeam;
    const redNoc = redBelt ? `${redTeam} | Sabuk ${redBelt}` : redTeam;

    return (
        <Page size="A4" orientation="portrait" style={styles.page}>
            <Text style={styles.eventHeader}>{eventName}</Text>

            <View style={[styles.row, { marginBottom: 8, alignItems: 'center' }]}>
                <View style={{ width: '33%' }}>
                    <Text style={[styles.fontBold, { fontSize: 9.5 }]}>
                        <Text style={styles.textRed}>WORLD </Text>
                        <Text style={styles.textBlue}>TAEKWONDO</Text>
                    </Text>
                </View>
                <View style={{ width: '33%', alignItems: 'center' }}>
                    <Text style={[styles.fontBold, { fontSize: 18 }]}>TA SHEET</Text>
                </View>
                <View style={{ width: '33%', alignItems: 'flex-end' }}>
                    <Text style={[styles.fontBold, { fontSize: 14 }]}>Best of 3</Text>
                </View>
            </View>

            <View style={styles.table}>
                <View style={styles.row}>
                    <View style={[styles.cell, { width: '33%' }]}><Text><Text style={styles.fontBold}>Date:</Text> {dateText}</Text></View>
                    <View style={[styles.cell, { width: '33%' }]}><Text><Text style={styles.fontBold}>Day no.:</Text> {dayNo}</Text></View>
                    <View style={[styles.cell, { width: '34%' }]}><Text><Text style={styles.fontBold}>Court no.:</Text> {courtNo}</Text></View>
                </View>
                <View style={styles.row}>
                    <View style={[styles.cell, { width: '33%' }]}><Text><Text style={styles.fontBold}>Match no.: </Text><Text style={[styles.fontBold, styles.font11]}>{matchNo}</Text></Text></View>
                    <View style={[styles.cell, { width: '33%' }]}><Text><Text style={styles.fontBold}>Weight category:</Text> {weightCategory}</Text></View>
                    <View style={[styles.cell, { width: '17%' }]}><Text style={styles.fontBold}>Hit level: {hitLevel}</Text></View>
                    <View style={[styles.cell, { width: '17%' }]}><Text style={styles.fontBold}>PSS Size: {pssSize}</Text></View>
                </View>
            </View>

            <View style={[styles.row, { justifyContent: 'space-between', marginBottom: 6 }]}>
                <View style={[styles.table, { width: '49%', marginBottom: 0 }]}>
                    <View style={styles.row}>
                        <View style={[styles.cell, styles.bgBlue, styles.cellCenter, { width: '100%', paddingVertical: 4 }]}><Text style={[styles.textWhite, styles.fontBold, styles.font14]}>CHUNG</Text></View>
                    </View>
                    <View style={styles.row}>
                        <View style={[styles.cell, { width: '25%' }]}><Text style={styles.fontBold}>NAME</Text></View>
                        <View style={[styles.cell, { width: '75%' }]}><Text style={[styles.fontBold, styles.font11]}>{blueName}</Text></View>
                    </View>
                    <View style={styles.row}>
                        <View style={[styles.cell, { width: '25%' }]}><Text style={styles.fontBold}>NOC</Text></View>
                        <View style={[styles.cell, { width: '75%' }]}><Text style={styles.font7_5}>{blueNoc}</Text></View>
                    </View>
                </View>

                <View style={[styles.table, { width: '49%', marginBottom: 0 }]}>
                    <View style={styles.row}>
                        <View style={[styles.cell, styles.bgRed, styles.cellCenter, { width: '100%', paddingVertical: 4 }]}><Text style={[styles.textWhite, styles.fontBold, styles.font14]}>HONG</Text></View>
                    </View>
                    <View style={styles.row}>
                        <View style={[styles.cell, { width: '25%' }]}><Text style={styles.fontBold}>NAME</Text></View>
                        <View style={[styles.cell, { width: '75%' }]}><Text style={[styles.fontBold, styles.font11]}>{redName}</Text></View>
                    </View>
                    <View style={styles.row}>
                        <View style={[styles.cell, { width: '25%' }]}><Text style={styles.fontBold}>NOC</Text></View>
                        <View style={[styles.cell, { width: '75%' }]}><Text style={styles.font7_5}>{redNoc}</Text></View>
                    </View>
                </View>
            </View>

            <View style={styles.table}>
                <View style={[styles.row, styles.bgGray, styles.fontBold]}>
                    <View style={[styles.cell, styles.cellCenter, { width: '15%' }]}><Text>Gam-Jeom</Text></View>
                    <View style={[styles.cell, styles.cellCenter, { width: '20%' }]}><Text>Deuk-Jeom</Text></View>
                    <View style={[styles.cell, styles.cellCenter, { width: '30%' }]}><Text>Round Winner</Text></View>
                    <View style={[styles.cell, styles.cellCenter, { width: '20%' }]}><Text>Deuk-Jeom</Text></View>
                    <View style={[styles.cell, styles.cellCenter, { width: '15%' }]}><Text>Gam-Jeom</Text></View>
                </View>
                {[1, 2, 3].map((round) => (
                    <View key={round} style={[styles.row, { minHeight: 28 }]}>
                        <View style={[styles.cell, { width: '15%' }]} />
                        <View style={[styles.cell, { width: '20%' }]} />
                        <View style={{ width: '30%', flexDirection: 'row' }}>
                            <View style={[styles.cell, styles.cellCenter, { flex: 1 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9]}>CHUNG</Text></View>
                            <View style={[styles.cell, styles.cellCenter, styles.bgGray, { flex: 1 }]}><Text style={[styles.fontBold, styles.font11]}>R{round}</Text></View>
                            <View style={[styles.cell, styles.cellCenter, { flex: 1 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9]}>HONG</Text></View>
                        </View>
                        <View style={[styles.cell, { width: '20%' }]} />
                        <View style={[styles.cell, { width: '15%' }]} />
                    </View>
                ))}
            </View>

            <View style={styles.table}>
                <View style={styles.row}>
                    <View style={[styles.cell, styles.cellCenter, styles.bgGray, { width: '100%', paddingVertical: 4 }]}><Text style={styles.fontBold}>DECISION OF ROUND SUPERIORITY</Text></View>
                </View>
                <View style={[styles.row, { minHeight: 40 }]}>
                    <View style={{ width: '15%', flexDirection: 'column' }}>
                        <View style={[styles.cell, styles.cellCenter, { flex: 1, paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9]}>Superiority</Text></View>
                        <View style={[styles.row, { flex: 1 }]}>
                            {['J3', 'J2', 'J1'].map((label) => <View key={label} style={[styles.cell, styles.cellCenter, { width: '33.33%', paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9]}>{label}</Text></View>)}
                        </View>
                    </View>
                    <View style={[styles.cell, styles.cellCenter, { width: '5%', paddingVertical: 0, paddingHorizontal: 2 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9, styles.textCenter]}>Reg.{"\n"}Hits</Text></View>
                    <View style={{ width: '18%', flexDirection: 'column' }}>
                        <View style={[styles.cell, styles.cellCenter, { flex: 1, paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9]}>Highest pts value</Text></View>
                        <View style={[styles.row, { flex: 1 }]}>
                            {['GJ', '1', '2', '3'].map((label) => <View key={label} style={[styles.cell, styles.cellCenter, { width: '25%', paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9]}>{label}</Text></View>)}
                        </View>
                    </View>
                    <View style={[styles.cell, styles.cellCenter, { width: '7%', paddingVertical: 0, paddingHorizontal: 2 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font9, styles.textCenter]}>Turning{"\n"}kicks pts</Text></View>
                    <View style={[styles.cell, styles.cellCenter, styles.bgGray, { width: '10%' }]}><Text style={styles.fontBold}>ROUND</Text></View>
                    <View style={[styles.cell, styles.cellCenter, { width: '7%', paddingVertical: 0, paddingHorizontal: 2 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9, styles.textCenter]}>Turning{"\n"}kicks pts</Text></View>
                    <View style={{ width: '18%', flexDirection: 'column' }}>
                        <View style={[styles.cell, styles.cellCenter, { flex: 1, paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9]}>Highest pts value</Text></View>
                        <View style={[styles.row, { flex: 1 }]}>
                            {['3', '2', '1', 'GJ'].map((label) => <View key={label} style={[styles.cell, styles.cellCenter, { width: '25%', paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9]}>{label}</Text></View>)}
                        </View>
                    </View>
                    <View style={[styles.cell, styles.cellCenter, { width: '5%', paddingVertical: 0, paddingHorizontal: 2 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9, styles.textCenter]}>Reg.{"\n"}Hits</Text></View>
                    <View style={{ width: '15%', flexDirection: 'column' }}>
                        <View style={[styles.cell, styles.cellCenter, { flex: 1, paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9]}>Superiority</Text></View>
                        <View style={[styles.row, { flex: 1 }]}>
                            {['J1', 'J2', 'J3'].map((label) => <View key={label} style={[styles.cell, styles.cellCenter, { width: '33.33%', paddingVertical: 0 }]}><Text style={[styles.fontBold, styles.textRed, styles.font9]}>{label}</Text></View>)}
                        </View>
                    </View>
                </View>
                {[1, 2, 3].map((round) => (
                    <View key={round} style={[styles.row, { minHeight: 18 }]}>
                        {[...Array(3)].map((_, i) => <View key={`l_sup_${i}`} style={[styles.cell, { width: '5%' }]} />)}
                        <View style={[styles.cell, { width: '5%' }]} />
                        {[...Array(4)].map((_, i) => <View key={`l_high_${i}`} style={[styles.cell, { width: '4.5%' }]} />)}
                        <View style={[styles.cell, { width: '7%' }]} />
                        <View style={[styles.cell, styles.cellCenter, styles.bgGray, { width: '10%' }]}><Text style={[styles.fontBold, styles.font9]}>R{round}</Text></View>
                        <View style={[styles.cell, { width: '7%' }]} />
                        {[...Array(4)].map((_, i) => <View key={`r_high_${i}`} style={[styles.cell, { width: '4.5%' }]} />)}
                        <View style={[styles.cell, { width: '5%' }]} />
                        {[...Array(3)].map((_, i) => <View key={`r_sup_${i}`} style={[styles.cell, { width: '5%' }]} />)}
                    </View>
                ))}
            </View>

            <View style={styles.table}>
                <View style={styles.row}>
                    {['PTF', 'RSC', 'WDR', 'DSQ', 'DQB'].map((penalty) => (
                        <View key={penalty} style={[styles.cell, styles.cellCenter, { width: '20%', paddingVertical: 4 }]}><Text style={styles.fontBold}>{penalty}</Text></View>
                    ))}
                </View>
            </View>

            <View style={[styles.row, { justifyContent: 'space-between', alignItems: 'flex-start' }]}>
                <View style={[styles.table, { width: '34%', marginBottom: 0 }]}>
                    <View style={styles.row}>
                        <View style={[styles.cell, styles.cellCenter, styles.bgBlue, { width: '46%' }]}><Text style={[styles.fontBold, styles.font7_5, styles.textWhite]}>Reason</Text></View>
                        <View style={[styles.cell, styles.cellCenter, styles.bgBlue, { width: '54%' }]}><Text style={[styles.fontBold, styles.font7_5, styles.textWhite]}>Chung Video Replay</Text></View>
                    </View>
                    {vrReasons.map((reason) => (
                        <View key={reason} style={styles.row}>
                            <View style={[styles.cell, { width: '46%', alignItems: 'flex-start', paddingVertical: 3 }]}><Text style={styles.font7_5}>{reason}</Text></View>
                            {[1, 2, 3].map((slot) => <View key={slot} style={[styles.cell, styles.cellCenter, { width: '18%' }]}><Text style={styles.font7_5}>A / R</Text></View>)}
                        </View>
                    ))}
                </View>

                <View style={[styles.table, { width: '20%', marginBottom: 0, flexDirection: 'column' }]}>
                    <View style={[styles.row, styles.cellCenter, styles.fontBold, { paddingVertical: 3, borderBottom: '1pt solid #000', borderRight: '1pt solid #000' }]}><Text>MATCH WINNER</Text></View>
                    <View style={styles.row}>
                        <View style={[styles.cell, styles.cellCenter, { width: '50%', height: 50 }]}><Text style={[styles.fontBold, styles.textBlue, styles.font11]}>CHUNG</Text></View>
                        <View style={[styles.cell, styles.cellCenter, { width: '50%', height: 50 }]}><Text style={[styles.fontBold, styles.textRed, styles.font11]}>HONG</Text></View>
                    </View>
                    <View style={[styles.row, styles.cellCenter, styles.fontBold, { paddingVertical: 3, borderBottom: '1pt solid #000', borderRight: '1pt solid #000' }]}><Text>Rounds won</Text></View>
                    <View style={styles.row}>
                        <View style={[styles.cell, { width: '50%', height: 30 }]} />
                        <View style={[styles.cell, { width: '50%', height: 30 }]} />
                    </View>
                </View>

                <View style={[styles.table, { width: '34%', marginBottom: 0 }]}>
                    <View style={styles.row}>
                        <View style={[styles.cell, styles.cellCenter, styles.bgRed, { width: '46%' }]}><Text style={[styles.fontBold, styles.font7_5, styles.textWhite]}>Reason</Text></View>
                        <View style={[styles.cell, styles.cellCenter, styles.bgRed, { width: '54%' }]}><Text style={[styles.fontBold, styles.font7_5, styles.textWhite]}>Hong Video Replay</Text></View>
                    </View>
                    {vrReasons.map((reason) => (
                        <View key={reason} style={styles.row}>
                            <View style={[styles.cell, { width: '46%', alignItems: 'flex-start', paddingVertical: 3 }]}><Text style={styles.font7_5}>{reason}</Text></View>
                            {[1, 2, 3].map((slot) => <View key={slot} style={[styles.cell, styles.cellCenter, { width: '18%' }]}><Text style={styles.font7_5}>A / R</Text></View>)}
                        </View>
                    ))}
                </View>
            </View>

            <View style={[styles.row, { justifyContent: 'space-between', marginTop: 5 }]}>
                {[0, 1].map((idx) => (
                    <View key={idx} style={[styles.table, { width: '48.5%', marginBottom: 0 }]}>
                        <View style={[styles.row, { minHeight: 18 }]}>
                            <View style={[styles.cell, styles.cellCenter, styles.bgYellow, styles.fontBold, { width: '40%' }]}><Text>Yellow card</Text></View>
                            <View style={[styles.cell, { width: '30%', justifyContent: 'flex-start', alignItems: 'flex-start', paddingTop: 2, paddingLeft: 4 }]}><Text style={styles.font6}>Round:</Text></View>
                            <View style={[styles.cell, { width: '30%', justifyContent: 'flex-start', alignItems: 'flex-start', paddingTop: 2, paddingLeft: 4 }]}><Text style={styles.font6}>Time:</Text></View>
                        </View>
                    </View>
                ))}
            </View>

            <View style={[styles.table, { marginTop: 6 }]}>
                <View style={[styles.row, styles.bgGray, styles.cellCenter, styles.fontBold]}>
                    {['Judge 3', 'Judge 2', 'Judge 1', 'Referee'].map((label) => (
                        <View key={label} style={[styles.cell, styles.cellCenter, { width: '25%' }]}><Text>{label}</Text></View>
                    ))}
                </View>
                <View style={[styles.row, { minHeight: 35 }]}>
                    {[1, 2, 3, 4].map((slot) => <View key={slot} style={[styles.cell, { width: '25%' }]} />)}
                </View>
                <View style={[styles.row, styles.bgGray, styles.cellCenter, styles.fontBold]}>
                    {['NOC', 'NOC', 'NOC', 'NOC'].map((label, idx) => (
                        <View key={`${label}-${idx}`} style={[styles.cell, styles.cellCenter, { width: '25%' }]}><Text>{label}</Text></View>
                    ))}
                </View>
                <View style={[styles.row, { minHeight: 18 }]}>
                    {[1, 2, 3, 4].map((slot) => <View key={slot} style={[styles.cell, { width: '25%' }]} />)}
                </View>
            </View>

            <View style={[styles.row, { marginTop: 12, fontSize: 10 }]}>
                <View style={{ width: '50%', paddingRight: 10 }}>
                    <Text style={[styles.fontBold, { textDecoration: 'underline', marginBottom: 12 }]}>Technical assistant</Text>
                    <Text style={{ marginBottom: 12, fontSize: 9 }}>Name: ________________________   No: _____   NOC: _____</Text>
                    <Text style={{ fontSize: 9 }}>Signature: __________________________</Text>
                </View>
                <View style={{ width: '50%' }}>
                    <Text style={[styles.fontBold, { textDecoration: 'underline', marginBottom: 12 }]}>Review jury</Text>
                    <Text style={{ marginBottom: 12, fontSize: 9 }}>Name: ________________________   No: _____   NOC: _____</Text>
                    <Text style={{ fontSize: 9 }}>Signature: __________________________</Text>
                </View>
            </View>
        </Page>
    );
};

export default PDFTASheetPage;
